<template>
  <v-toolbar-items v-if="items && items.length" dense no-gutters style="overflow: hidden">
    <!-- Elipses menu for small screens -->
    <v-menu offset-y class="hidden-md-and-up">
      <template v-slot:activator="{ on }">
        <v-btn class="hidden-md-and-up" exact small active-class v-on="on" icon>
          <v-icon small>fa-ellipsis-vertical</v-icon>
        </v-btn>
      </template>
      <v-list class="hidden-md-and-up">
        <div v-for="(menuItem, i) in menuItems" :key="'menuitem' + i">
          <v-menu
            :disabled="!menuItem.items || !menuItem.items.length"
            open-on-hover
            offset-x
            transition="scroll-y-transition"
            right
          >
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" :key="'lst_' + i" @click.capture.stop="$emit('crumb-click', menuItem, $event)">
                <v-list-item-icon v-if="menuItem.icon">
                  <v-icon color="primary">{{ menuItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <span class="text-truncate truncated-title">{{ menuItem.title }}</span>
                </v-list-item-title>
                <v-list-item-action v-if="menuItem.items && menuItem.items.length">
                  <v-icon small style="margin-left: 14px">fa-solid fa-angle-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <BreadcrumbSubList :value="menuItem.items" @click="$emit('crumb-click', $event)"></BreadcrumbSubList>
          </v-menu>
        </div>
      </v-list>
    </v-menu>

    <!-- Single breadcrumb for small screens -->
    <BreadcrumbItem :value="lastItem" class="hidden-md-and-up" @click="$emit('crumb-click', $event)"></BreadcrumbItem>

    <!-- Full breadcrumbs for larger screens -->
    <template v-for="(item, i) in items" class="hidden-sm-and-down">
      <BreadcrumbItem
        :key="'crumb_' + i"
        :value="item"
        class="hidden-sm-and-down"
        @click="$emit('crumb-click', $event)"
      ></BreadcrumbItem>
      <v-icon class="hidden-sm-and-down" :key="'icn_' + i" v-if="i < items.length - 1" x-small> fa-angle-right </v-icon>
    </template>
  </v-toolbar-items>
</template>
<script>
import BreadcrumbItem from './BreadcrumbItem.vue'
import BreadcrumbSubList from './BreadcrumbSubList.vue'
export default {
  name: 'Breadcrumbs',
  props: {
    items: {
      type: Array,
      description: 'Array of breadcrumb items',
      default: function () {
        return []
      }
    }
  },
  components: {
    BreadcrumbItem,
    BreadcrumbSubList
  },
  computed: {
    menuItems() {
      return this.items.slice(0, -1)
    },
    lastItem() {
      return this.items.at(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.truncated-title {
  max-width: 585px;
}
</style>
